import Swiper, {Autoplay, EffectFade} from "swiper";

Swiper.use([EffectFade])

export default class Recent {
    constructor() {
        if (document.getElementById('recent') !== null) {
            this.recentSlider();
        }
    }

    recentSlider() {

        function initSlider() {

            const container = document.querySelectorAll('#recent .swiper-container')


            // First swiper
            let firstSwiper = new Swiper('#recent .top-slider .swiper-container', {
                slidesPerView: 'auto',
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false
                },
                speed: 8000,


            });

            // Second swiper
            let secondSwiper = new Swiper('#recent .bottom-slider .swiper-container', {

                slidesPerView: 'auto',
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false
                },
                speed: 8000,




            });

            // Disable autoplay when mouse enters swiper-container
            document.querySelectorAll('.swiper-container').forEach(function(container) {
                container.addEventListener('mouseenter', function() {
                    firstSwiper.autoplay.stop();
                    secondSwiper.autoplay.stop();
                });
            });

            // Enable autoplay when mouse leaves swiper-container
            document.querySelectorAll('.swiper-container').forEach(function(container) {
                container.addEventListener('mouseleave', function() {
                    firstSwiper.autoplay.start();
                    secondSwiper.autoplay.start();
                });
            });

        }

        initSlider();


    }

}
